import { useForTablet } from 'components/Breakpoint'
import { useMemo } from 'react'
import { isWASMSupported, isWebGLSupported } from 'utils'

const webGL = isWebGLSupported()
const wasm = isWASMSupported()

/**
 * Hook gathers together all values indicating the level of support for the
 * Web Renderer in the current browser.
 */
export const useWebRendererSupport = () => {
  const viewport = useForTablet()
  const supported = useMemo(() => viewport && webGL && wasm, [viewport])

  return {
    detail: { viewport, webGL, wasm },
    supported,
  } as const
}
